module.exports = __webpack_public_path__ + "assets/successNote2Icon-7e6a65.svg";